module.exports = __webpack_public_path__ + "img/gun-turret-gun-mask.8061de70.png";